import loadable from '@loadable/component';

import { LoadableLoadingSection } from 'components/LoadableLoadingSection';

export const SearchPageContainerLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "SearchPageContainer" */
      './SearchPageContainer.dynamic'
    ),
  { fallback: <LoadableLoadingSection /> },
);
